import React, { createContext, useContext, useState, useEffect, useRef } from 'react';
import { INITIAL_PRODUCTS } from '../data/productsData';
import { INITIAL_BLOGS } from '../data/blogsData';
import { INITIAL_PAGES } from '../data/pagesData';
import { DEFAULT_CMS_CONTENT } from '../data/defaultCmsData';
import { CATEGORIES, MIZAJ_LIST, AILMENTS_LIST } from '../data/categoriesData';

const StoreContext = createContext();

const DEFAULT_SETTINGS = {
  storeNameUrdu: 'ہمالین پنسار سٹور',
  storeNameEn: 'Himalayan Pansar Store',
  dawakhanaNameUrdu: 'دواخانہ طب پاکستانی',
  dawakhanaNameEn: 'Dawakhana Tib-e-Pakistani',
  hakimNameUrdu: 'حکیم مولانا سید عبدالوہاب شاہ شیرازی',
  hakimNameEn: 'Hakim Maulana Syed Abdul Wahab Shah Shirazi',
  logoUrl: '',
  faviconUrl: '',
  phone: '03470005578',
  whatsappNumber: '923470005578',
  email: 'sherazi313@gmail.com',
  addressUrdu: 'ہمالین پنسار، شاپ 10، رائل پلازہ، نزد کے ایف سی، ای الیون ٹو مرکز اسلام آباد',
  addressEn: 'Himalayan Pansar, Shop 10, Royal Plaza, Near KFC, E-11/2 Markaz, Islamabad',
  deliveryFee: 200,
  freeDeliveryThreshold: 5000,
  enableCod: true,
  codAdvanceRequired: true,
  codAdvanceAmount: 500,
  easypaisaAccount: '03470005578 (سید عبدالوہاب شاہ)',
  bankName: 'یو بی ایل (UBL - United Bank Limited)',
  bankAccountTitle: 'سید عبدالوہاب شاہ (Syed Abdul Wahab Shah)',
  bankIban: 'PK56UNIL0109000290123386',
  bankAccountNumber: '0109000290123386',
  bankQrUrl: '/images/ubl-qr-code.jpg',
  bankDetails: 'یو بی ایل (UBL) | IBAN: PK56UNIL0109000290123386 | ٹائٹل: سید عبدالوہاب شاہ',
  adminPin: '',
  adminUsername: 'admin',
  adminPassword: '',
  adminSecretSlug: 'sherazi-5083',
  adminEmails: ['sherazi313@gmail.com'],
  twoFactorType: 'disabled', // 'disabled' | 'email_otp' | 'totp'
  totpSecret: '',
  enableSocialProof: true
};

const SAMPLE_ORDERS = [];

const SAMPLE_REVIEWS = [
  {
    id: 'rev-1',
    productId: 'hp-kalonji-01',
    customerName: 'حاجی محمد ادریس',
    city: 'لاہور',
    orderId: 'HP-9041',
    rating: 5,
    comment: 'ماشاءاللہ بہت ہی خالص اور معیاری کلونجی ہے۔ میں روزانہ صبح نہار منہ استعمال کر رہا ہوں، معدے کے مسائل اور کمزوری میں نمایاں فائدہ ہوا ہے۔ جزاک اللہ حکیم صاحب۔',
    date: '2026-09-08',
    status: 'approved'
  },
  {
    id: 'rev-2',
    productId: 'hp-jawarish-kamuni-02',
    customerName: 'طارق محمود صدیقی',
    city: 'اسلام آباد',
    orderId: 'HP-8994',
    rating: 5,
    comment: 'گیس، تبخیر اور پیٹ کے بھاری پن کے لیے لاجواب دوا ہے۔ صابر ملتانیؒ کے اصولوں کے مطابق بنی ہوئی حقیقی طبِ پاکستانی ہے۔',
    date: '2026-09-09',
    status: 'approved'
  },
  {
    id: 'rev-3',
    productId: 'hp-majun-falasfa-04',
    customerName: 'سید عابد علی شاہ',
    city: 'راولپنڈی',
    orderId: 'HP-9042',
    rating: 5,
    comment: 'کمر درد اور گردوں کی کمزوری کے لیے استعمال کی، الحمدللہ ایک ہفتے میں ہی بہت بہتر نتائج ملے۔ پیکنگ اور ڈلیوری بھی بروقت تھی۔',
    date: '2026-09-10',
    status: 'approved'
  },
  {
    id: 'rev-4',
    productId: 'hp-khamira-marwareed-05',
    customerName: 'ڈاکٹر فرہاد خان',
    city: 'پشاور',
    orderId: 'HP-8910',
    rating: 5,
    comment: 'دل کی گھبراہٹ اور ذہنی تناؤ کے لیے خمیرہ مروارید جواہر دار واقعی کمال کا اثر رکھتی ہے۔ خالص ادویات کے لیے ہمالین پنسار قابلِ اعتماد ہے۔',
    date: '2026-09-11',
    status: 'approved'
  }
];

const CURRENT_DATA_VERSION = '2026-09-16-v14';

export const normalizeProduct = (p) => {
  if (!p) return p;
  const images = Array.isArray(p.images) && p.images.length > 0 
    ? p.images.filter(Boolean)
    : (p.image ? [p.image] : []);
  const primaryImage = images[0] || p.image || '';
  return {
    ...p,
    image: primaryImage,
    images: images.length > 0 ? images : (primaryImage ? [primaryImage] : [])
  };
};

// Safe non-destructive initialization (NEVER overwrite existing user products, categories, or settings)
if (typeof window !== 'undefined') {
  try {
    // Only populate if completely empty (first time visit)
    if (!localStorage.getItem('himalayan_products')) {
      localStorage.setItem('himalayan_products', JSON.stringify(INITIAL_PRODUCTS));
    }
    if (!localStorage.getItem('himalayan_blogs')) {
      localStorage.setItem('himalayan_blogs', JSON.stringify(INITIAL_BLOGS));
    }
    if (!localStorage.getItem('himalayan_store_settings')) {
      localStorage.setItem('himalayan_store_settings', JSON.stringify(DEFAULT_SETTINGS));
    }
    if (!localStorage.getItem('himalayan_cms_content')) {
      localStorage.setItem('himalayan_cms_content', JSON.stringify(DEFAULT_CMS_CONTENT));
    }
    if (!localStorage.getItem('himalayan_categories')) {
      localStorage.setItem('himalayan_categories', JSON.stringify(CATEGORIES));
    }
    if (!localStorage.getItem('himalayan_ailments')) {
      localStorage.setItem('himalayan_ailments', JSON.stringify(AILMENTS_LIST));
    }
    if (!localStorage.getItem('himalayan_mizaj')) {
      localStorage.setItem('himalayan_mizaj', JSON.stringify(MIZAJ_LIST));
    }
    if (!localStorage.getItem('himalayan_reviews')) {
      localStorage.setItem('himalayan_reviews', JSON.stringify(SAMPLE_REVIEWS));
    }
  } catch (err) {
    console.warn('Could not initialize local data storage:', err);
  }
}

export const StoreProvider = ({ children }) => {
  // Settings
  const [settings, setSettings] = useState(() => {
    const saved = localStorage.getItem('himalayan_store_settings');
    if (!saved) return DEFAULT_SETTINGS;
    try {
      const parsed = JSON.parse(saved);
      return {
        ...DEFAULT_SETTINGS,
        ...parsed,
        enableCod: parsed.enableCod !== undefined ? Boolean(parsed.enableCod) : true,
        codAdvanceRequired: parsed.codAdvanceRequired !== undefined ? Boolean(parsed.codAdvanceRequired) : true,
        codAdvanceAmount: Number(parsed.codAdvanceAmount) || 500
      };
    } catch {
      return DEFAULT_SETTINGS;
    }
  });

  // Products (Direct User / Server Data - Never forced with dummy initial products)
  const [products, setProducts] = useState(() => {
    try {
      const saved = localStorage.getItem('himalayan_products') || localStorage.getItem('himalayan_products_vault_backup');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed) && parsed.length > 0) {
          return parsed.map(normalizeProduct);
        }
      }
    } catch (e) {
      console.error('Error loading products from storage:', e);
    }
    return [];
  });

  // Orders
  const [orders, setOrders] = useState(() => {
    const saved = localStorage.getItem('himalayan_orders');
    return saved ? JSON.parse(saved) : SAMPLE_ORDERS;
  });

  // CMS Content (Hero, Announcements, Bio, Footer, FAQs, Trust Badges, Tibbi Diagnosis, Section Titles, Social Links)
  const [cmsContent, setCmsContent] = useState(() => {
    const saved = localStorage.getItem('himalayan_cms_content');
    if (!saved) return DEFAULT_CMS_CONTENT;
    try {
      const parsed = JSON.parse(saved);
      return {
        ...DEFAULT_CMS_CONTENT,
        ...parsed,
        announcement: {
          textUrdu: (parsed.announcement?.textUrdu || DEFAULT_CMS_CONTENT.announcement.textUrdu).replace(/2[,\s]?500/g, '5,000'),
          textEn: (parsed.announcement?.textEn || DEFAULT_CMS_CONTENT.announcement.textEn).replace(/2[,\s]?500/g, '5,000')
        },
        hero: { ...DEFAULT_CMS_CONTENT.hero, ...(parsed.hero || {}) },
        sectionTitles: { ...DEFAULT_CMS_CONTENT.sectionTitles, ...(parsed.sectionTitles || {}) },
        hakimProfile: { ...DEFAULT_CMS_CONTENT.hakimProfile, ...(parsed.hakimProfile || {}) },
        tibbiDiagnosis: {
          ...DEFAULT_CMS_CONTENT.tibbiDiagnosis,
          ...(parsed.tibbiDiagnosis || {}),
          archetypes: (Array.isArray(parsed.tibbiDiagnosis?.archetypes) && parsed.tibbiDiagnosis.archetypes.length > 0)
            ? parsed.tibbiDiagnosis.archetypes
            : DEFAULT_CMS_CONTENT.tibbiDiagnosis.archetypes
        },
        trustBadges: (parsed.trustBadges && parsed.trustBadges.length > 0) ? parsed.trustBadges : DEFAULT_CMS_CONTENT.trustBadges,
        faqs: (parsed.faqs && parsed.faqs.length > 0) ? parsed.faqs : DEFAULT_CMS_CONTENT.faqs,
        footer: { ...DEFAULT_CMS_CONTENT.footer, ...(parsed.footer || {}) },
        socialLinks: { ...DEFAULT_CMS_CONTENT.socialLinks, ...(parsed.socialLinks || {}) }
      };
    } catch {
      return DEFAULT_CMS_CONTENT;
    }
  });

  // Categories (Smart Non-Destructive Merge)
  const [categories, setCategories] = useState(() => {
    try {
      const saved = localStorage.getItem('himalayan_categories');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed) && parsed.length > 0) {
          const catMap = new Map();
          CATEGORIES.forEach(c => catMap.set(c.id, c));
          parsed.forEach(c => {
            if (c && c.id) {
              const existing = catMap.get(c.id);
              catMap.set(c.id, { ...existing, ...c });
            }
          });
          return Array.from(catMap.values());
        }
      }
    } catch (e) {
      console.error('Error loading categories:', e);
    }
    return CATEGORIES;
  });

  // Ailments
  const [ailments, setAilments] = useState(() => {
    const saved = localStorage.getItem('himalayan_ailments');
    return saved ? JSON.parse(saved) : AILMENTS_LIST;
  });

  // Mizaj List
  const [mizajList, setMizajList] = useState(() => {
    const saved = localStorage.getItem('himalayan_mizaj');
    return saved ? JSON.parse(saved) : MIZAJ_LIST;
  });

  // Reviews
  const [reviews, setReviews] = useState(() => {
    const saved = localStorage.getItem('himalayan_reviews');
    return saved ? JSON.parse(saved) : SAMPLE_REVIEWS;
  });

  // Helper to normalize blog records for backward/forward compatibility
  const normalizeBlog = (b) => {
    if (!b) return b;
    const titleVal = b.title || b.titleUrdu || b.titleEn || '';
    const excerptVal = b.excerpt || b.excerptUrdu || b.excerptEn || '';
    
    // Check if image is broken or pointing to non-existent local product path
    let imageVal = b.featuredImage || b.coverImage || '';
    if (!imageVal || (imageVal.startsWith('/images/products/') && !imageVal.includes('shilajit'))) {
      const initMatch = INITIAL_BLOGS.find(ib => ib.id === b.id || ib.slug === b.slug);
      imageVal = initMatch?.coverImage || 'https://images.unsplash.com/photo-1546069901-ba9599a7e63c?w=1200&auto=format&fit=crop&q=80';
    }

    const contentVal = b.content || b.contentHtml || '';
    return {
      ...b,
      title: titleVal,
      titleUrdu: b.titleUrdu || titleVal,
      excerpt: excerptVal,
      excerptUrdu: b.excerptUrdu || excerptVal,
      featuredImage: imageVal,
      coverImage: imageVal,
      content: contentVal,
      contentHtml: b.contentHtml || contentVal,
      category: b.category || 'herbs',
      categoryUrdu: b.categoryUrdu || 'جڑی بوٹیاں و نباتات'
    };
  };

  // Blogs & Articles
  const [blogs, setBlogs] = useState(() => {
    try {
      const saved = localStorage.getItem('himalayan_blogs');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed) && parsed.length > 0) {
          return parsed.map(normalizeBlog);
        }
      }
    } catch (e) {
      console.error('Error loading blogs from storage:', e);
    }
    return INITIAL_BLOGS.map(normalizeBlog);
  });


  // Pages
  const [pages, setPages] = useState(() => {
    try {
      const saved = localStorage.getItem('himalayan_pages');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed) && parsed.length > 0) {
          const systemPages = INITIAL_PAGES.filter(p => p.category === 'system');
          systemPages.forEach(sp => {
            if (!parsed.find(p => p.id === sp.id)) {
              parsed.push(sp);
            }
          });
          return parsed;
        }
      }
    } catch (e) {}
    return INITIAL_PAGES;
  });

  // Media Library
  const [mediaLibrary, setMediaLibrary] = useState(() => {
    try {
      const saved = localStorage.getItem('himalayan_media_library');
      if (saved) {
        const parsed = JSON.parse(saved);
        if (Array.isArray(parsed)) return parsed;
      }
    } catch (e) {
      console.error('Error loading media library:', e);
    }
    return [];
  });

  // Admin Auth & Token Management
  const [adminToken, setAdminToken] = useState(() => {
    return localStorage.getItem('himalayan_admin_token') || null;
  });
  const [isAdminAuthenticated, setIsAdminAuthenticated] = useState(() => {
    return !!localStorage.getItem('himalayan_admin_token') || localStorage.getItem('himalayan_admin_auth') === 'true';
  });

  // Verify Admin Token with Server on Boot
  useEffect(() => {
    const verifyServerSession = async () => {
      const savedToken = localStorage.getItem('himalayan_admin_token');
      if (!savedToken) return;

      try {
        const checkUrl = getStoreApiUrl('status');
        const res = await fetch(checkUrl);
        if (res.ok) {
          // If server is reachable, verify token
          const authCheckUrl = window.location.pathname.includes('/himalayan')
            ? '/himalayan/api/auth.php?action=check'
            : '/api/auth.php?action=check';
          const authRes = await fetch(authCheckUrl, {
            headers: {
              'Authorization': `Bearer ${savedToken}`,
              'X-Admin-Token': savedToken
            }
          });
          const text = await authRes.text();
          try {
            const data = JSON.parse(text);
            if (data && data.authenticated === false) {
              setIsAdminAuthenticated(false);
              setAdminToken(null);
              localStorage.removeItem('himalayan_admin_token');
              localStorage.removeItem('himalayan_admin_auth');
            }
          } catch (e) {}
        }
      } catch (e) {
        // Keep current state if offline
      }
    };
    verifyServerSession();
  }, []);

  // Hostinger Server Sync Status: 'connecting' | 'connected' | 'offline'
  const [serverSyncStatus, setServerSyncStatus] = useState('connecting');

  // Helper to dynamically resolve store.php endpoint
  const getStoreApiUrl = (action) => {
    const origin = typeof window !== 'undefined' ? window.location.origin : '';
    const isSubfolder = typeof window !== 'undefined' && window.location.pathname.includes('/himalayan');
    const basePath = isSubfolder ? '/himalayan/api/store.php' : '/api/store.php';
    return `${origin}${basePath}?action=${action}`;
  };

  // Helper to send data directly to Hostinger server disk
  const syncSectionToServer = async (action, payload) => {
    try {
      const headers = { 'Content-Type': 'application/json' };
      const currentToken = adminToken || localStorage.getItem('himalayan_admin_token');
      if (currentToken) {
        headers['Authorization'] = `Bearer ${currentToken}`;
        headers['X-Admin-Token'] = currentToken;
      }

      const res = await fetch(getStoreApiUrl(action), {
        method: 'POST',
        headers,
        body: JSON.stringify(payload)
      });
      if (res.ok) {
        setServerSyncStatus('connected');
      }
    } catch (err) {
      setServerSyncStatus('offline');
    }
  };

  // Helper to delete physical image file from Hostinger /uploads/ folder
  const deleteImageFromServer = async (imageUrl) => {
    if (!imageUrl || typeof imageUrl !== 'string') return;
    if (!imageUrl.includes('uploads/')) return;
    try {
      const origin = typeof window !== 'undefined' ? window.location.origin : '';
      const isSubfolder = typeof window !== 'undefined' && window.location.pathname.includes('/himalayan');
      const uploadUrl = `${origin}${isSubfolder ? '/himalayan/api/upload.php?action=delete' : '/api/upload.php?action=delete'}`;
      const headers = { 'Content-Type': 'application/json' };
      const currentToken = adminToken || localStorage.getItem('himalayan_admin_token');
      if (currentToken) {
        headers['Authorization'] = `Bearer ${currentToken}`;
        headers['X-Admin-Token'] = currentToken;
      }

      await fetch(uploadUrl, {
        method: 'POST',
        headers,
        body: JSON.stringify({ action: 'delete', file: imageUrl })
      });
    } catch (e) {
      console.warn('Could not delete image file from server:', e);
    }
  };

  // Realtime browser Favicon & Site Icon updater
  useEffect(() => {
    try {
      const faviconUrl = settings?.faviconUrl;
      let link = document.querySelector("link[rel~='icon']");
      if (!link) {
        link = document.createElement('link');
        link.rel = 'icon';
        document.getElementsByTagName('head')[0].appendChild(link);
      }
      if (faviconUrl && faviconUrl.trim()) {
        link.href = faviconUrl;
        if (faviconUrl.startsWith('data:image/svg+xml') || faviconUrl.endsWith('.svg')) {
          link.type = 'image/svg+xml';
        } else if (faviconUrl.endsWith('.png') || faviconUrl.startsWith('data:image/png')) {
          link.type = 'image/png';
        } else if (faviconUrl.endsWith('.ico')) {
          link.type = 'image/x-icon';
        } else {
          link.type = 'image/jpeg';
        }
      } else {
        // Default herbal leaf SVG favicon
        link.href = "data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 100 100'><text y='.9em' font-size='90'>🌿</text></svg>";
        link.type = "image/svg+xml";
      }
    } catch (e) {
      console.warn('Favicon update error:', e);
    }
  }, [settings?.faviconUrl]);

  const isInitialLoaded = useRef(false);

  // Fetch / Refresh Store Data from Hostinger Server MySQL / Disk
  const fetchServerStoreData = async (overrideToken = null) => {
    try {
      const token = overrideToken || adminToken || localStorage.getItem('himalayan_admin_token');
      const headers = {};
      if (token) {
        headers['Authorization'] = `Bearer ${token}`;
        headers['X-Admin-Token'] = token;
      }

      const res = await fetch(getStoreApiUrl('load'), { headers });
      if (res.ok) {
        const data = await res.json();
        if (data && data.status !== 'empty') {
          if (Array.isArray(data.products)) {
            setProducts(data.products.map(normalizeProduct));
            localStorage.setItem('himalayan_products', JSON.stringify(data.products));
          }
          if (Array.isArray(data.categories) && data.categories.length > 0) {
            setCategories(data.categories);
            localStorage.setItem('himalayan_categories', JSON.stringify(data.categories));
          }
          if (data.settings) {
            setSettings(prev => ({
              ...prev,
              ...data.settings,
              adminUsername: data.settings.adminUsername || prev.adminUsername || 'admin',
              adminSecretSlug: data.settings.adminSecretSlug || prev.adminSecretSlug || 'sherazi-5083',
              twoFactorType: data.settings.twoFactorType || prev.twoFactorType || 'disabled',
              adminEmails: (Array.isArray(data.settings.adminEmails) && data.settings.adminEmails.length > 0)
                ? data.settings.adminEmails
                : (prev.adminEmails || ['sherazi313@gmail.com'])
            }));
            localStorage.setItem('himalayan_store_settings', JSON.stringify(data.settings));
          }
          if (data.cmsContent) {
            setCmsContent(data.cmsContent);
            localStorage.setItem('himalayan_cms_content', JSON.stringify(data.cmsContent));
          }
          if (Array.isArray(data.ailments) && data.ailments.length > 0) {
            setAilments(data.ailments);
            localStorage.setItem('himalayan_ailments', JSON.stringify(data.ailments));
          }
          if (Array.isArray(data.mizajList) && data.mizajList.length > 0) {
            setMizajList(data.mizajList);
            localStorage.setItem('himalayan_mizaj', JSON.stringify(data.mizajList));
          }
          if (Array.isArray(data.orders)) {
            setOrders(data.orders);
            localStorage.setItem('himalayan_orders', JSON.stringify(data.orders));
          }
          if (Array.isArray(data.reviews)) {
            setReviews(data.reviews);
            localStorage.setItem('himalayan_reviews', JSON.stringify(data.reviews));
          }
          if (Array.isArray(data.blogs)) {
            setBlogs(data.blogs);
            localStorage.setItem('himalayan_blogs', JSON.stringify(data.blogs));
          }
          setServerSyncStatus('connected');
        } else if (data && data.status === 'empty') {
          // First time only if database is completely empty: check if local storage has custom products
          const localSavedProds = localStorage.getItem('himalayan_products');
          if (localSavedProds) {
            try {
              const parsed = JSON.parse(localSavedProds);
              if (Array.isArray(parsed) && parsed.length > 0) {
                setProducts(parsed.map(normalizeProduct));
                syncSectionToServer('save_products', { products: parsed });
              }
            } catch (e) {}
          }
          setServerSyncStatus('connected');
        }
      }
    } catch (err) {
      setServerSyncStatus('offline');
    } finally {
      isInitialLoaded.current = true;
    }
  };

  // 1. Initial Load from Hostinger Server MySQL / Disk
  useEffect(() => {
    fetchServerStoreData();
  }, []);

  // Save changes locally and sync automatically to Hostinger Server ONLY after initial load and if authenticated
  useEffect(() => {
    if (!isInitialLoaded.current) return;
    try {
      localStorage.setItem('himalayan_store_settings', JSON.stringify(settings));
    } catch (e) {
      console.warn('Storage quota warning (settings):', e);
    }
    if (isAdminAuthenticated) {
      syncSectionToServer('save_settings', { settings });
    }
  }, [settings, isAdminAuthenticated]);

  useEffect(() => {
    if (!isInitialLoaded.current) return;
    try {
      localStorage.setItem('himalayan_products', JSON.stringify(products));
      localStorage.setItem('himalayan_products_vault_backup', JSON.stringify(products));
    } catch (e) {
      console.warn('Storage quota warning (products):', e);
    }
    syncSectionToServer('save_products', { products });
  }, [products]);

  useEffect(() => {
    if (!isInitialLoaded.current) return;
    try {
      localStorage.setItem('himalayan_orders', JSON.stringify(orders));
    } catch (e) {
      console.warn('Storage quota warning (orders):', e);
    }
    syncSectionToServer('save_orders', { orders });
  }, [orders]);

  useEffect(() => {
    if (!isInitialLoaded.current) return;
    try {
      localStorage.setItem('himalayan_cms_content', JSON.stringify(cmsContent));
    } catch (e) {
      console.warn('Storage quota warning (cmsContent):', e);
    }
    syncSectionToServer('save_cms', { cmsContent });
  }, [cmsContent]);

  useEffect(() => {
    if (!isInitialLoaded.current) return;
    try {
      localStorage.setItem('himalayan_categories', JSON.stringify(categories));
    } catch (e) {
      console.warn('Storage quota warning (categories):', e);
    }
    syncSectionToServer('save_categories', { categories });
  }, [categories]);

  useEffect(() => {
    if (!isInitialLoaded.current) return;
    try {
      localStorage.setItem('himalayan_ailments', JSON.stringify(ailments));
    } catch (e) {
      console.warn('Storage quota warning (ailments):', e);
    }
    syncSectionToServer('save_ailments', { ailments });
  }, [ailments]);

  useEffect(() => {
    if (!isInitialLoaded.current) return;
    try {
      localStorage.setItem('himalayan_mizaj', JSON.stringify(mizajList));
    } catch (e) {
      console.warn('Storage quota warning (mizaj):', e);
    }
    syncSectionToServer('save_mizaj', { mizajList });
  }, [mizajList]);

  useEffect(() => {
    if (!isInitialLoaded.current) return;
    try {
      localStorage.setItem('himalayan_reviews', JSON.stringify(reviews));
    } catch (e) {
      console.warn('Storage quota warning (reviews):', e);
    }
    syncSectionToServer('save_reviews', { reviews });
  }, [reviews]);

  useEffect(() => {
    if (!isInitialLoaded.current) return;
    try {
      localStorage.setItem('himalayan_blogs', JSON.stringify(blogs));
    } catch (e) {
      console.warn('Storage quota warning (blogs):', e);
    }
    syncSectionToServer('save_blogs', { blogs });
  }, [blogs]);


  useEffect(() => {
    if (!isInitialLoaded.current) return;
    try {
      localStorage.setItem('himalayan_pages', JSON.stringify(pages));
    } catch (e) {
      console.warn('Storage quota warning (pages):', e);
    }
    syncSectionToServer('save_pages', { pages });
  }, [pages]);

  useEffect(() => {
    if (!isInitialLoaded.current) return;
    try {
      localStorage.setItem('himalayan_media_library', JSON.stringify(mediaLibrary));
    } catch (e) {
      console.warn('Storage quota warning (mediaLibrary):', e);
    }
    syncSectionToServer('save_media', { mediaLibrary });
  }, [mediaLibrary]);

  useEffect(() => {
    try {
      localStorage.setItem('himalayan_admin_auth', isAdminAuthenticated ? 'true' : 'false');
    } catch (e) {
      console.warn('Storage quota warning (adminAuth):', e);
    }
  }, [isAdminAuthenticated]);

  // Product Actions
  const addProduct = (newProduct) => {
    const normalized = normalizeProduct(newProduct);
    const productWithId = {
      ...normalized,
      id: normalized.id || `prod-${Date.now()}`,
      rating: normalized.rating || 5.0,
      reviewsCount: normalized.reviewsCount || 1
    };
    setProducts(prev => [productWithId, ...prev]);
    return productWithId;
  };

  const updateProduct = (updatedProduct) => {
    const normalized = normalizeProduct(updatedProduct);
    setProducts(prev => prev.map(p => p.id === normalized.id ? normalized : p));
  };

  const deleteProduct = (productId) => {
    const productToDelete = products.find(p => p.id === productId);
    if (productToDelete) {
      const imgsToDelete = [];
      if (productToDelete.image && productToDelete.image.includes('uploads/')) {
        imgsToDelete.push(productToDelete.image);
      }
      if (Array.isArray(productToDelete.images)) {
        productToDelete.images.forEach(img => {
          if (img && img.includes('uploads/') && !imgsToDelete.includes(img)) {
            imgsToDelete.push(img);
          }
        });
      }
      imgsToDelete.forEach(imgUrl => {
        deleteImageFromServer(imgUrl);
      });
    }
    setProducts(prev => prev.filter(p => p.id !== productId));
  };

  const toggleStock = (productId) => {
    setProducts(prev => prev.map(p => {
      if (p.id === productId) {
        return { ...p, inStock: !p.inStock };
      }
      return p;
    }));
  };

  // Order Actions
  const addOrder = (orderData) => {
    const orderId = `HP-${Math.floor(1000 + Math.random() * 9000)}`;
    const now = new Date();
    const formattedDate = `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')} ${String(now.getHours()).padStart(2, '0')}:${String(now.getMinutes()).padStart(2, '0')}`;

    const newOrder = {
      ...orderData,
      id: orderId,
      date: formattedDate,
      status: 'Pending'
    };

    setOrders(prev => [newOrder, ...prev]);
    return newOrder;
  };

  const updateOrderStatus = (orderId, newStatus) => {
    setOrders(prev => prev.map(o => o.id === orderId ? { ...o, status: newStatus } : o));
  };

  const deleteOrder = (orderId) => {
    setOrders(prev => prev.filter(o => o.id !== orderId));
  };

  // Settings Actions
  const updateSettings = (newSettings) => {
    setSettings(prev => ({ ...prev, ...newSettings }));
  };

  // CMS Content Actions
  const updateCmsContent = (newCmsContent) => {
    setCmsContent(prev => ({
      ...prev,
      ...newCmsContent
    }));
  };

  const resetCmsToDefaults = () => {
    setCmsContent(DEFAULT_CMS_CONTENT);
    localStorage.removeItem('himalayan_cms_content');
  };

  // Category Actions
  const addCategory = (newCat) => {
    const slug = newCat.id && newCat.id.trim()
      ? newCat.id.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-')
      : `cat-${Date.now()}`;
    const categoryWithId = {
      ...newCat,
      id: slug,
      icon: newCat.icon || 'Leaf',
      bgGradient: newCat.bgGradient || 'from-emerald-800 to-emerald-950',
      accentColor: newCat.accentColor || 'text-emerald-400',
      itemCount: newCat.itemCount || '0 اشیاء'
    };
    setCategories(prev => [...prev, categoryWithId]);
    return categoryWithId;
  };

  const updateCategory = (updatedCat) => {
    setCategories(prev => prev.map(c => c.id === updatedCat.id ? updatedCat : c));
  };

  const deleteCategory = (catId) => {
    setCategories(prev => prev.filter(c => c.id !== catId));
  };

  const resetCategoriesToDefaults = () => {
    setCategories(CATEGORIES);
    localStorage.removeItem('himalayan_categories');
  };

  // Ailment Actions
  const addAilment = (newAilment) => {
    const slug = newAilment.id && newAilment.id.trim()
      ? newAilment.id.toLowerCase().trim().replace(/[^a-z0-9]+/g, '-')
      : `ailment-${Date.now()}`;
    const item = { ...newAilment, id: slug };
    setAilments(prev => [...prev, item]);
    return item;
  };

  const updateAilment = (updatedAilment) => {
    setAilments(prev => prev.map(a => a.id === updatedAilment.id ? updatedAilment : a));
  };

  const deleteAilment = (ailmentId) => {
    setAilments(prev => prev.filter(a => a.id !== ailmentId));
  };

  const resetAilmentsToDefaults = () => {
    setAilments(AILMENTS_LIST);
    localStorage.removeItem('himalayan_ailments');
  };

  // Mizaj Actions
  const updateMizaj = (updatedMizaj) => {
    setMizajList(prev => prev.map(m => m.id === updatedMizaj.id ? updatedMizaj : m));
  };

  const resetMizajToDefaults = () => {
    setMizajList(MIZAJ_LIST);
    localStorage.removeItem('himalayan_mizaj');
  };

  // Reviews Actions
  const addReview = (reviewData) => {
    const newRev = {
      id: `rev-${Date.now()}`,
      productId: reviewData.productId,
      customerName: reviewData.customerName?.trim() || 'معزز خریدار',
      city: reviewData.city?.trim() || '',
      orderId: reviewData.orderId?.trim() || '',
      rating: Number(reviewData.rating) || 5,
      comment: reviewData.comment?.trim() || '',
      date: new Date().toISOString().split('T')[0],
      status: 'approved'
    };
    setReviews(prev => [newRev, ...prev]);
    return newRev;
  };

  const updateReviewStatus = (reviewId, newStatus) => {
    setReviews(prev => prev.map(r => r.id === reviewId ? { ...r, status: newStatus } : r));
  };

  const deleteReview = (reviewId) => {
    setReviews(prev => prev.filter(r => r.id !== reviewId));
  };

  const getProductReviews = (productId) => {
    return reviews.filter(r => r.productId === productId && r.status === 'approved');
  };

  const getProductRatingStats = (productId, baseRating = 4.9, baseCount = 20) => {
    const approved = reviews.filter(r => r.productId === productId && r.status === 'approved');
    if (approved.length === 0) {
      return { rating: baseRating, count: baseCount, userReviews: [] };
    }
    const totalStars = approved.reduce((sum, r) => sum + (Number(r.rating) || 5), 0);
    const avg = (totalStars / approved.length).toFixed(1);
    return {
      rating: parseFloat(avg),
      count: approved.length + baseCount,
      userReviews: approved
    };
  };

  // Blog & Article Actions
  const addBlog = (blogData) => {
    const normalized = normalizeBlog(blogData);
    const newBlog = {
      ...normalized,
      id: `blog-${Date.now()}`,
      slug: (normalized.slug || normalized.titleUrdu || `article-${Date.now()}`).trim().toLowerCase().replace(/[\s\W-]+/g, '-').slice(0, 50),
      publishedDate: normalized.publishedDate || new Date().toISOString().slice(0, 10),
      viewsCount: 0,
      status: normalized.status || 'published'
    };
    setBlogs(prev => [newBlog, ...prev]);
    return newBlog;
  };

  const updateBlog = (blogId, updatedData) => {
    setBlogs(prev => prev.map(b => b.id === blogId ? normalizeBlog({ ...b, ...updatedData }) : b));
  };

  const deleteBlog = (blogId) => {
    setBlogs(prev => prev.filter(b => b.id !== blogId));
  };

  const getBlogBySlug = (slugOrId) => {
    if (!slugOrId) return null;
    return blogs.find(b => b.slug === slugOrId || b.id === slugOrId);
  };

  const getBlogById = (id) => {
    if (!id) return null;
    return blogs.find(b => b.id === id);
  };


  // Page Actions
  const addPage = (pageData) => {
    const newPage = {
      ...pageData,
      id: `page-${Date.now()}`,
      slug: (pageData.slug || pageData.titleUrdu || `page-${Date.now()}`).trim().toLowerCase().replace(/[^a-z0-9\u0600-\u06FF-]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 50),
      publishedDate: pageData.publishedDate || new Date().toISOString().slice(0, 10),
      status: pageData.status || 'published'
    };
    setPages(prev => [newPage, ...prev]);
    return newPage;
  };

  const updatePage = (pageId, updatedData) => {
    setPages(prev => prev.map(p => p.id === pageId ? { ...p, ...updatedData } : p));
  };

  const deletePage = (pageId) => {
    setPages(prev => prev.filter(p => p.id !== pageId));
  };

  const getPageBySlug = (slugOrId) => {
    if (!slugOrId) return null;
    const clean = slugOrId.toString().trim().toLowerCase().replace(/^\/+|\/+$/g, '');
    const cleanNorm = clean.replace(/[\u064A\u0649]/g, '\u06CC').replace(/[\u0643]/g, '\u06A9').replace(/[\u0647\u06BE]/g, '\u06C1');
    return pages.find(p => {
      if (!p) return false;
      const pSlug = (p.slug || '').toString().trim().toLowerCase().replace(/^\/+|\/+$/g, '');
      const pSlugNorm = pSlug.replace(/[\u064A\u0649]/g, '\u06CC').replace(/[\u0643]/g, '\u06A9').replace(/[\u0647\u06BE]/g, '\u06C1');
      const pTitle = (p.titleUrdu || p.title || '').toString().trim().toLowerCase();
      const pTitleNorm = pTitle.replace(/[\u064A\u0649]/g, '\u06CC').replace(/[\u0643]/g, '\u06A9').replace(/[\u0647\u06BE]/g, '\u06C1');
      return p.id === clean || pSlug === clean || pSlugNorm === cleanNorm || pTitle === clean || pTitleNorm === cleanNorm;
    });
  };

  const incrementBlogViews = (blogId) => {
    setBlogs(prev => prev.map(b => {
      if (b.id === blogId) {
        return { ...b, viewsCount: (b.viewsCount || 0) + 1 };
      }
      return b;
    }));
  };

  // Full Backup (Export JSON)
  const exportFullBackup = () => {
    const backupData = {
      version: CURRENT_DATA_VERSION,
      timestamp: new Date().toISOString(),
      settings,
      products,
      categories,
      ailments,
      mizajList,
      cmsContent,
      orders,
      reviews: reviews || [],
      blogs: blogs || []
    };
    const blob = new Blob([JSON.stringify(backupData, null, 2)], { type: 'application/json' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `pansar-store-backup-${new Date().toISOString().slice(0, 10)}.json`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const importFullBackup = (backupObj) => {
    try {
      const data = typeof backupObj === 'string' ? JSON.parse(backupObj) : backupObj;
      if (data.settings) {
        setSettings(data.settings);
        localStorage.setItem('himalayan_store_settings', JSON.stringify(data.settings));
      }
      if (Array.isArray(data.products)) {
        setProducts(data.products);
        localStorage.setItem('himalayan_products', JSON.stringify(data.products));
      }
      if (Array.isArray(data.categories)) {
        setCategories(data.categories);
        localStorage.setItem('himalayan_categories', JSON.stringify(data.categories));
      }
      if (Array.isArray(data.ailments)) {
        setAilments(data.ailments);
        localStorage.setItem('himalayan_ailments', JSON.stringify(data.ailments));
      }
      if (Array.isArray(data.mizajList)) {
        setMizajList(data.mizajList);
        localStorage.setItem('himalayan_mizaj', JSON.stringify(data.mizajList));
      }
      if (data.cmsContent) {
        setCmsContent(data.cmsContent);
        localStorage.setItem('himalayan_cms_content', JSON.stringify(data.cmsContent));
      }
      if (Array.isArray(data.orders)) {
        setOrders(data.orders);
        localStorage.setItem('himalayan_orders', JSON.stringify(data.orders));
      }
      if (Array.isArray(data.reviews)) {
        setReviews(data.reviews);
        localStorage.setItem('himalayan_reviews', JSON.stringify(data.reviews));
      }
      if (Array.isArray(data.blogs)) {
        setBlogs(data.blogs);
        localStorage.setItem('himalayan_blogs', JSON.stringify(data.blogs));
      }
      localStorage.setItem('himalayan_data_version', CURRENT_DATA_VERSION);
      return { success: true };
    } catch (err) {
      return { success: false, error: err.message };
    }
  };

  // Export Codebase JS Files for Git Commit
  const getProductsJsCode = () => {
    return `export const INITIAL_PRODUCTS = ${JSON.stringify(products, null, 2)};\n`;
  };

  const downloadProductsJsFile = () => {
    const code = getProductsJsCode();
    const blob = new Blob([code], { type: 'application/javascript;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'productsData.js';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const getCategoriesJsCode = () => {
    return `export const CATEGORIES = ${JSON.stringify(categories, null, 2)};\n\nexport const MIZAJ_LIST = ${JSON.stringify(mizajList, null, 2)};\n\nexport const AILMENTS_LIST = ${JSON.stringify(ailments, null, 2)};\n`;
  };

  const downloadCategoriesJsFile = () => {
    const code = getCategoriesJsCode();
    const blob = new Blob([code], { type: 'application/javascript;charset=utf-8' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'categoriesData.js';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  const resetToDefaults = () => {
    setProducts(INITIAL_PRODUCTS);
    setSettings(DEFAULT_SETTINGS);
    setOrders(SAMPLE_ORDERS);
    setCategories(CATEGORIES);
    setAilments(AILMENTS_LIST);
    setMizajList(MIZAJ_LIST);
    setReviews(SAMPLE_REVIEWS);
    setBlogs(INITIAL_BLOGS);
    resetCmsToDefaults();
    localStorage.setItem('himalayan_products', JSON.stringify(INITIAL_PRODUCTS));
    localStorage.setItem('himalayan_store_settings', JSON.stringify(DEFAULT_SETTINGS));
    localStorage.setItem('himalayan_orders', JSON.stringify(SAMPLE_ORDERS));
    localStorage.setItem('himalayan_cms_content', JSON.stringify(DEFAULT_CMS_CONTENT));
    localStorage.setItem('himalayan_categories', JSON.stringify(CATEGORIES));
    localStorage.setItem('himalayan_ailments', JSON.stringify(AILMENTS_LIST));
    localStorage.setItem('himalayan_mizaj', JSON.stringify(MIZAJ_LIST));
    localStorage.setItem('himalayan_reviews', JSON.stringify(SAMPLE_REVIEWS));
    localStorage.setItem('himalayan_blogs', JSON.stringify(INITIAL_BLOGS));
    localStorage.setItem('himalayan_data_version', CURRENT_DATA_VERSION);
  };

  // Media Library CRUD & Sync Actions
  const addMedia = (newMedia) => {
    const mediaObj = {
      ...newMedia,
      id: newMedia.id || `media-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
      createdAt: newMedia.createdAt || new Date().toISOString().slice(0, 10)
    };
    setMediaLibrary(prev => [mediaObj, ...prev.filter(m => m.url !== mediaObj.url)]);
    return mediaObj;
  };

  const updateMedia = (mediaId, updatedFields) => {
    setMediaLibrary(prev => prev.map(m => m.id === mediaId ? { ...m, ...updatedFields } : m));
  };

  const deleteMedia = (mediaId) => {
    const item = mediaLibrary.find(m => m.id === mediaId);
    if (item && item.url && item.url.includes('uploads/')) {
      deleteImageFromServer(item.url);
    }
    setMediaLibrary(prev => prev.filter(m => m.id !== mediaId));
  };

  const syncMediaFromStore = () => {
    setMediaLibrary(prev => {
      const existingUrls = new Set(prev.map(m => m.url));
      const newItems = [];

      const addIfNew = (url, title, altText) => {
        if (!url || typeof url !== 'string' || !url.trim()) return;
        const cleanUrl = url.trim();
        if (!existingUrls.has(cleanUrl)) {
          existingUrls.add(cleanUrl);
          newItems.push({
            id: `media-${Date.now()}-${Math.random().toString(36).substr(2, 6)}`,
            url: cleanUrl,
            title: title || 'تصویر',
            caption: '',
            altText: altText || title || 'ہربل معلوماتی تصویر',
            description: '',
            dimensions: '1200 × 800',
            fileSize: cleanUrl.startsWith('data:') ? 'WebP' : 'آن لائن لنک',
            fileType: 'image/webp',
            createdAt: new Date().toISOString().slice(0, 10)
          });
        }
      };

      products.forEach(p => {
        if (p.image) addIfNew(p.image, p.nameUrdu || p.name, p.nameUrdu || p.name);
        if (Array.isArray(p.images)) {
          p.images.forEach(img => addIfNew(img, p.nameUrdu || p.name, p.nameUrdu || p.name));
        }
      });

      blogs.forEach(b => {
        if (b.coverImage) addIfNew(b.coverImage, b.titleUrdu || b.title, b.titleUrdu || b.title);
        if (b.featuredImage) addIfNew(b.featuredImage, b.titleUrdu || b.title, b.titleUrdu || b.title);
        const html = b.contentHtml || b.content || '';
        const imgMatches = html.match(/src=["']([^"']+)["']/g);
        if (imgMatches) {
          imgMatches.forEach(m => {
            const src = m.replace(/src=["']/, '').replace(/["']$/, '');
            addIfNew(src, b.titleUrdu || 'بلاگ تصویر', b.titleUrdu || 'بلاگ تصویر');
          });
        }
      });

      pages.forEach(pg => {
        if (pg.coverImage) addIfNew(pg.coverImage, pg.titleUrdu || pg.title, pg.titleUrdu || pg.title);
        const html = pg.contentHtml || pg.content || '';
        const imgMatches = html.match(/src=["']([^"']+)["']/g);
        if (imgMatches) {
          imgMatches.forEach(m => {
            const src = m.replace(/src=["']/, '').replace(/["']$/, '');
            addIfNew(src, pg.titleUrdu || 'پیج تصویر', pg.titleUrdu || 'پیج تصویر');
          });
        }
      });

      if (settings.logoUrl) addIfNew(settings.logoUrl, 'سٹور لوگو', 'لوگو');
      if (settings.bankQrUrl) addIfNew(settings.bankQrUrl, 'بینک کیو آر کوڈ', 'کیو آر کوڈ');
      if (cmsContent?.hero?.backgroundImage) addIfNew(cmsContent.hero.backgroundImage, 'ہوم پیج بینر تصویر', 'بینر');
      if (cmsContent?.hakimProfile?.image) addIfNew(cmsContent.hakimProfile.image, 'حکیم مولانا سید عبدالوہاب شاہ', 'حکیم صاحب');

      if (newItems.length > 0) {
        return [...prev, ...newItems];
      }
      return prev;
    });
  };

  // Base32 Decoder for Client-side TOTP verification
  const base32ToBytes = (base32) => {
    const alphabet = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ234567';
    const clean = (base32 || '').toUpperCase().replace(/[^A-Z2-7]/g, '');
    let bits = '';
    for (let i = 0; i < clean.length; i++) {
      const val = alphabet.indexOf(clean[i]);
      if (val === -1) continue;
      bits += val.toString(2).padStart(5, '0');
    }
    const bytes = [];
    for (let i = 0; i + 8 <= bits.length; i += 8) {
      bytes.push(parseInt(bits.substring(i, i + 8), 2));
    }
    return new Uint8Array(bytes);
  };

  // Pure JS / WebCrypto RFC 6238 TOTP Verifier for Local/Client Support
  const verifyClientTotp = async (secret, inputCode, windowSteps = 1) => {
    try {
      if (!secret || !inputCode) return false;
      const cleanInput = inputCode.toString().trim();
      if (cleanInput.length !== 6) return false;

      const keyBytes = base32ToBytes(secret);
      if (keyBytes.length === 0) return false;

      const cryptoKey = await window.crypto.subtle.importKey(
        'raw',
        keyBytes,
        { name: 'HMAC', hash: { name: 'SHA-1' } },
        false,
        ['sign']
      );

      const currentTimeSlice = Math.floor(Date.now() / 1000 / 30);

      for (let i = -windowSteps; i <= windowSteps; i++) {
        const timeSlice = currentTimeSlice + i;
        const buffer = new ArrayBuffer(8);
        const view = new DataView(buffer);
        view.setBigUint64(0, BigInt(timeSlice));

        const signature = await window.crypto.subtle.sign('HMAC', cryptoKey, buffer);
        const hmacBytes = new Uint8Array(signature);
        const offset = hmacBytes[hmacBytes.length - 1] & 0x0f;
        const codeValue =
          ((hmacBytes[offset] & 0x7f) << 24) |
          ((hmacBytes[offset + 1] & 0xff) << 16) |
          ((hmacBytes[offset + 2] & 0xff) << 8) |
          (hmacBytes[offset + 3] & 0xff);

        const generatedCode = (codeValue % 1000000).toString().padStart(6, '0');
        if (generatedCode === cleanInput) {
          return true;
        }
      }
      return false;
    } catch (err) {
      console.warn('Local TOTP verification error:', err);
      return false;
    }
  };

  // Admin Login via Secure Server API with 2FA and Local Dev Fallback
  const loginAdmin = async (username, password) => {
    const trimmedUser = (username || '').trim();
    const trimmedPass = (password || '').trim();

    try {
      const origin = typeof window !== 'undefined' ? window.location.origin : '';
      const isSubfolder = typeof window !== 'undefined' && window.location.pathname.includes('/himalayan');
      const authUrl = `${origin}${isSubfolder ? '/himalayan/api/auth.php?action=login' : '/api/auth.php?action=login'}`;
      const savedDevToken = localStorage.getItem('hp_2fa_device_token') || '';

      const res = await fetch(authUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Device-Token': savedDevToken
        },
        body: JSON.stringify({
          username: trimmedUser,
          password: trimmedPass,
          device_token: savedDevToken
        })
      });

      const text = await res.text();
      let data = null;
      try {
        data = JSON.parse(text);
      } catch (jsonErr) {}

      if (data && data.requires_2fa && data.temp_token) {
        return {
          requires2fa: true,
          tempToken: data.temp_token,
          twoFactorType: data.twoFactorType,
          message: data.message
        };
      }

      if (data && res.ok && data.status === 'success' && data.token) {
        setAdminToken(data.token);
        localStorage.setItem('himalayan_admin_token', data.token);
        localStorage.setItem('himalayan_admin_auth', 'true');
        setIsAdminAuthenticated(true);
        await fetchServerStoreData(data.token);
        return { success: true };
      } else if (data && data.message) {
        return {
          success: false,
          message: data.message
        };
      }
    } catch (err) {
      // Server offline / network error
    }

    // Local / Offline Dev Fallback (Only if server is unreachable):
    const localUser = settings?.adminUsername || 'admin';
    const localPass = settings?.adminPassword || settings?.adminPin || '1234';

    if (
      trimmedUser.toLowerCase() === localUser.toLowerCase() &&
      trimmedPass === localPass
    ) {
      const twoFactor = settings?.twoFactorType || 'disabled';
      const isTrusted = !!localStorage.getItem('hp_2fa_device_token');

      if (twoFactor !== 'disabled' && !isTrusted) {
        const localTempToken = 'local-temp-' + Date.now();
        if (twoFactor === 'email_otp') {
          const localOtp = Math.floor(100000 + Math.random() * 900000).toString();
          sessionStorage.setItem('hp_local_2fa', JSON.stringify({
            code: localOtp,
            type: 'email_otp',
            expires: Date.now() + 600000
          }));
          alert(`【لوکل ٹیسٹنگ نوٹس】\nای میل سرور آف لائن ہونے کی وجہ سے آپ کا 6 ہندسوں کا OTP کوڈ یہ ہے:\n\n👉  ${localOtp}\n\nاسے لاگ ان باکس میں درج کریں۔`);
          return {
            requires2fa: true,
            tempToken: localTempToken,
            twoFactorType: 'email_otp',
            message: 'لاگ ان مکمل کرنے کے لیے ای میل پر بھیجا گیا 6 ہندسوں کا OTP کوڈ درج کریں۔'
          };
        } else if (twoFactor === 'totp') {
          return {
            requires2fa: true,
            tempToken: localTempToken,
            twoFactorType: 'totp',
            message: 'اپنے موبائل کی Google Authenticator ایپ سے 6 ہندسوں کا وقتی کوڈ درج کریں۔'
          };
        }
      }

      setIsAdminAuthenticated(true);
      localStorage.setItem('himalayan_admin_auth', 'true');
      return { success: true };
    }

    return {
      success: false,
      message: 'غلط یوزر نیم یا پاس ورڈ! براہ کرم درست پاس ورڈ درج کریں۔'
    };
  };

  // 2FA Code Verification
  const verifyTwoFactorCode = async (tempToken, code, rememberDevice = false) => {
    const cleanCode = (code || '').trim();
    try {
      const origin = typeof window !== 'undefined' ? window.location.origin : '';
      const isSubfolder = typeof window !== 'undefined' && window.location.pathname.includes('/himalayan');
      const authUrl = `${origin}${isSubfolder ? '/himalayan/api/auth.php?action=verify_2fa' : '/api/auth.php?action=verify_2fa'}`;

      const res = await fetch(authUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          temp_token: tempToken,
          code: cleanCode,
          remember_device: rememberDevice
        })
      });

      const text = await res.text();
      let data = null;
      try {
        data = JSON.parse(text);
      } catch (jsonErr) {}

      if (data && res.ok && data.status === 'success' && data.token) {
        setAdminToken(data.token);
        localStorage.setItem('himalayan_admin_token', data.token);
        localStorage.setItem('himalayan_admin_auth', 'true');
        if (data.device_token) {
          localStorage.setItem('hp_2fa_device_token', data.device_token);
        }
        setIsAdminAuthenticated(true);
        await fetchServerStoreData(data.token);
        return { success: true, message: data.message };
      } else if (data && data.message) {
        return { success: false, message: data.message };
      }
    } catch (e) {
      // Server unreachable -> Check local fallback
    }

    // Local / Offline 2FA Verification Fallback:
    const twoFactor = settings?.twoFactorType || 'disabled';
    let verified = false;

    if (twoFactor === 'email_otp') {
      try {
        const savedOtpData = JSON.parse(sessionStorage.getItem('hp_local_2fa') || '{}');
        if (savedOtpData && savedOtpData.code === cleanCode && savedOtpData.expires > Date.now()) {
          verified = true;
          sessionStorage.removeItem('hp_local_2fa');
        }
      } catch (e) {}
    } else if (twoFactor === 'totp') {
      const currentSecret = settings?.totpSecret || 'KVKFK2TLNVWGS5DB';
      const totpValid = await verifyClientTotp(currentSecret, cleanCode);
      if (totpValid) {
        verified = true;
      }
    }

    if (verified) {
      if (rememberDevice) {
        localStorage.setItem('hp_2fa_device_token', 'local-trusted-' + Date.now());
      }
      setIsAdminAuthenticated(true);
      localStorage.setItem('himalayan_admin_auth', 'true');
      return { success: true, message: '2FA تصدیق کامیاب ہو گئی۔' };
    }

    return { success: false, message: 'درج کردہ 2FA سیکیورٹی کوڈ غلط ہے۔ دوبارہ کوشش کریں۔' };
  };

  const logoutAdmin = async () => {
    try {
      const origin = typeof window !== 'undefined' ? window.location.origin : '';
      const isSubfolder = typeof window !== 'undefined' && window.location.pathname.includes('/himalayan');
      const authUrl = `${origin}${isSubfolder ? '/himalayan/api/auth.php?action=logout' : '/api/auth.php?action=logout'}`;
      const currentToken = adminToken || localStorage.getItem('himalayan_admin_token');
      await fetch(authUrl, {
        headers: currentToken ? {
          'Authorization': `Bearer ${currentToken}`,
          'X-Admin-Token': currentToken
        } : {}
      });
    } catch (e) {}

    setAdminToken(null);
    localStorage.removeItem('himalayan_admin_token');
    localStorage.removeItem('himalayan_admin_auth');
    setIsAdminAuthenticated(false);

    // Clean address bar so admin secret slug is immediately removed on logout
    if (typeof window !== 'undefined') {
      const isSubfolder = window.location.pathname.includes('/himalayan');
      const cleanUrl = isSubfolder ? '/himalayan/' : '/';
      window.history.replaceState(null, '', cleanUrl);
    }
  };

  return (
    <StoreContext.Provider value={{
      settings,
      products,
      orders,
      cmsContent,
      categories,
      ailments,
      mizajList,
      isAdminAuthenticated,
      adminToken,
      addProduct,
      updateProduct,
      deleteProduct,
      toggleStock,
      addOrder,
      updateOrderStatus,
      deleteOrder,
      updateSettings,
      updateCmsContent,
      resetCmsToDefaults,
      addCategory,
      updateCategory,
      deleteCategory,
      resetCategoriesToDefaults,
      addAilment,
      updateAilment,
      deleteAilment,
      resetAilmentsToDefaults,
      updateMizaj,
      resetMizajToDefaults,
      reviews,
      addReview,
      updateReviewStatus,
      deleteReview,
      getProductReviews,
      getProductRatingStats,
      blogs,
      addBlog,
      updateBlog,
      deleteBlog,
      getBlogBySlug,
      deleteImageFromServer,
      getBlogById,
      pages,
      addPage,
      updatePage,
      deletePage,
      getPageBySlug,
      mediaLibrary,
      addMedia,
      updateMedia,
      deleteMedia,
      syncMediaFromStore,
      incrementBlogViews,
      exportFullBackup,
      importFullBackup,
      getProductsJsCode,
      downloadProductsJsFile,
      getCategoriesJsCode,
      downloadCategoriesJsFile,
      serverSyncStatus,
      resetToDefaults,
      loginAdmin,
      verifyTwoFactorCode,
      logoutAdmin
    }}>
      {children}
    </StoreContext.Provider>
  );
};

export const useStore = () => {
  const context = useContext(StoreContext);
  if (!context) {
    throw new Error('useStore must be used within a StoreProvider');
  }
  return context;
};
